module.exports = __webpack_public_path__ + "media/images/locus_logo-3df69e45f61dd4b5b8c63df039f9dc48.png";